const AI_ACTIONS = {
  CONVERSATION_STARTED: 'CONVERSATION_STARTED',
  CONVERSATION_UPDATED: 'CONVERSATION_UPDATED',
  CONVERSATION_ENDED: 'CONVERSATION_ENDED'
};

const conversationStartedAction = ({ promptId, conversationId }) => {
  return {
    type: AI_ACTIONS.CONVERSATION_STARTED,
    payload: { promptId, conversationId }
  };
};

const conversationUpdatedAction = messages => {
  return {
    type: AI_ACTIONS.CONVERSATION_UPDATED,
    payload: messages
  };
};

const conversationEndedAction = promptId => {
  return {
    type: AI_ACTIONS.CONVERSATION_ENDED,
    payload: promptId
  };
};

export {
  conversationUpdatedAction,
  conversationStartedAction,
  conversationEndedAction,
  AI_ACTIONS
};
